import { useMemo, useState } from "react";
import { buildTimezoneOptions } from "../timezones";

/**
 * Zones of the time zone panel filtered by the search query: by the name,
 * the IANA id or the offset ("kyiv", "new york", "utc+2").
 *
 * @param {string} timezone - current zone, always among the options
 * @returns {{
 *   query: string,
 *   setQuery: (query: string) => void,
 *   options: { timezone: string, name: string, offset: string }[],
 * }}
 */
const useTimezoneSearch = (timezone) => {
  const [query, setQuery] = useState("");

  const allOptions = useMemo(() => buildTimezoneOptions(timezone), [timezone]);
  const normalizedQuery = query.trim().toLowerCase();

  const options = useMemo(
    () =>
      normalizedQuery
        ? allOptions.filter((option) => option.searchText.includes(normalizedQuery))
        : allOptions,
    [allOptions, normalizedQuery],
  );

  return { query, setQuery, options };
};

export default useTimezoneSearch;
